
import downloadLocalFile from "./downloadLocalFile";


export default {

    downloadLocalFile,

}